/**
 * @ngdoc services
 * @memberof mercury.modules.stock
 * @name StockSuppliers
 * @description Data access service to manage company suppliers
 */
angular.module('mercury.modules.stock.supplier')
.factory('StockSuppliers', ["$resource", "settings", function($resource, settings) {

  var StockSuppliers = $resource(settings.stockHost + '/internal/suppliers/:id', { id: '@id' }, {
    update: {method: 'PUT'},
    patch: {url: settings.apiHost + '/r/StockSuppliers', method: 'PATCH'},
    merge: {url: settings.apiHost + '/a/StockSuppliers/Merge', method: 'PUT'}
  });

  var SupplierAliases = $resource(settings.stockHost + '/internal/suppliers/:supplierId/aliases', { supplierId: '@supplierId', aliasId: '@aliasId' }, {
    delete: {url: settings.stockHost + '/internal/suppliers/:supplierId/aliases/:aliasId', method: 'DELETE'}
  });

  /**
   * Get a summary list of all suppliers
   *
   * @memberof StockSuppliers
   */
  
  function getAll(includeDeletedSuppliers) {
    includeDeletedSuppliers = includeDeletedSuppliers || false;
    
    var queryParams = { includeDeletedSuppliers: includeDeletedSuppliers };
    
    // Return the query results with the query parameters
    return StockSuppliers.query(queryParams);
  }

  /**
   * Get the full details of a specific suppliers
   *
   * @memberof StockSuppliers
   * @param  {String} supplierId Id of the supplier to get
   */
  function get(supplierId) {
    return StockSuppliers.get({id: supplierId});
  }

  function getAliases(supplierId) {
    return SupplierAliases.query({supplierId: supplierId});
  }

  function deleteAlias(supplierId, aliasId) {
    return SupplierAliases.delete({supplierId: supplierId, aliasId: aliasId})
  }

  /**
   * Create a new supplier
   *
   * @memberof StockSuppliers
   * @param  {Object} newSupplier New supplier model
   */
  function create(newSupplier) {
    return StockSuppliers.save(newSupplier).$promise;
  }

  /**
   * Update an existing supplier
   *
   * @memberof StockSuppliers
   * @param  {Object} supplier Updated supplier model
   */
  function update(supplier) {
    return supplier.$update();
  }

  /**
   * Update a single field of the specifed supplier
   *
   * @memberof StockSuppliers
   * @param  {String} id    Id of the supplier to update
   * @param  {String} field Name of the field to update
   * @param  {String} value New value to set
   */
  function patch(id, field, value) {
    var patchValue = {};
    patchValue[field] = value;

    return StockSuppliers.patch({id: id}, patchValue).$promise;
  }

  /**
   * Set the specific supplier as deleted
   *
   * @memberof StockSuppliers
   * @param  {Object} supplier Model to the supplier to set as deleted
   */
  function remove(supplier) {
    // This is using datestampRemoved instead of removedAt
    // because this endpoint hasn't been moved to StockAPI
    return patch(supplier.id, 'datestampRemoved', moment().format());
  }

  /**
   * Set the specific supplier as not deleted
   *
   * @memberof StockSuppliers
   * @param  {String} supplier Model to the supplier to set as not deleted
   */
  function restore(supplier) {
    // This is using datestampRemoved instead of removedAt
    // because this endpoint hasn't been moved to StockAPI    
    return patch(supplier.id, 'datestampRemoved', null);
  }

  /**
   * Merge one supplier with an other, updating all references to the source supplier
   * with the destination and deleting the source supplier
   *
   * @memberof StockSuppliers
   * @param  {String} sourceId Id of the source supplier
   * @param  {String} destId   Id of the destination supplier
   */
  function merge(sourceId, destId) {
    return StockSuppliers.merge({sourceId: sourceId, destId: destId}, {}).$promise;
  }

  return {
    getAll: getAll,
    get: get,
    getAliases: getAliases,
    deleteAlias: deleteAlias,
    create: create,
    update: update,
    patch: patch,
    remove: remove,
    restore: restore,
    merge: merge
  };
}]);
